import React from 'react'
import { tokens } from './v4Styles'

const categoryColors = {
  needs_review: { bg: '#FF9800', text: '#fff' },
  aspire_tickets: { bg: '#7b1fa2', text: '#fff' },
  field_issues: { bg: '#c62828', text: '#fff' },
  stale: { bg: '#e65100', text: '#fff' },
  unread_messages: { bg: '#5d4037', text: '#fff' }
}

const formatTimeAgo = (date) => {
  if (!date) return ''
  const ms = Date.now() - new Date(date).getTime()
  const mins = Math.floor(ms / 60000)
  if (mins < 60) return `${mins}m`
  const hours = Math.floor(mins / 60)
  if (hours < 24) return `${hours}h`
  const days = Math.floor(hours / 24)
  return `${days}d`
}

const ReviewItemCard = ({ item, selected, onClick }) => {
  const colors = categoryColors[item.category] || categoryColors.stale
  return (
    <div
      onClick={() => onClick(item)}
      style={{
        padding: '10px 14px',
        borderBottom: '1px solid #f5f5f5',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        cursor: 'pointer',
        backgroundColor: selected ? '#e8f0fe' : 'transparent'
      }}
    >
      <span style={{
        background: colors.bg,
        color: colors.text,
        fontSize: 8,
        padding: '2px 7px',
        borderRadius: 8,
        fontWeight: 700,
        whiteSpace: 'nowrap'
      }}>
        {item.categoryLabel}
      </span>
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ fontWeight: 600, fontSize: 12, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {item.siteName || '(unnamed)'}
        </div>
        <div style={{ color: tokens.text.muted, fontSize: 10, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {item.summary}
        </div>
      </div>
      <span style={{ color: tokens.text.hint, fontSize: 10, whiteSpace: 'nowrap', flexShrink: 0 }}>
        {formatTimeAgo(item.timestamp)}
      </span>
    </div>
  )
}

export default ReviewItemCard
